import './Location.scss';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import { SvgIcon } from '@mui/material';
import ButtonField from '../../Components/Button/ButtonField';
import Table from '../../Components/Table/Table';
import CustomToolbar from '../../Components/Table/components/CustomToolbar';
import TableSearch from '../../Components/Table/components/TableSearch';
import { ILocationList, MastersProps } from './ILocation';
import {
  FunctionComponent,
  MouseEvent,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { ReactComponent as Add } from '../../Assets/Images/Add.svg';
import { ReactComponent as User } from '../../Assets/Images/User.svg';
import NoCrashIcon from '@mui/icons-material/NoCrash';
import { Columns } from '../../Components/Table/ITable';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import { getLocation } from '../../Redux/Slicers/Location/LocationSlicer';
import {
  GridActionsCellItem,
  GridRowParams,
  GridValueGetterParams,
} from '@mui/x-data-grid';
import ElectricCarIcon from '@mui/icons-material/ElectricCar';
import { ReactComponent as Edit } from '../../Assets/Images/Edit.svg';
import { ReactComponent as Delete } from '../../Assets/Images/Delete.svg';
import Dialog from '../../Components/Dialog/Dialog';
import IconButtonField from '../../Components/Button/IconButtonField';
import { ReactComponent as Cancel } from '../../Assets/Images/Cancel.svg';
import LocationForm from './LocationForm';
import { FormikProps } from 'formik';
import {
  clearUpdateLocationState,
  LocationsUpdateableData,
} from '../../Redux/Slicers/Location/UpdateLocationSlicer';
import ResponseDialog from '../../Components/ResponseDialog/ResponseDialog';
import DeleteDialog from '../../Components/DeleteDialog/DeleteDialog';
import {
  clearDeleteLocation,
  deleteLocation,
} from '../../Redux/Slicers/Location/DeleteLocationSlice';
import AdsClickOutlinedIcon from '@mui/icons-material/AdsClickOutlined';
import { ReactComponent as View } from '../../Assets/Images/solar_eye-linear.svg';
import { ReactComponent as AdsHistory } from '../../Assets/Images/ads_history.svg';
import ads from '../../Assets/Images/click-ads-4330.png';

import AdsClickIcon from '@mui/icons-material/AdsClick';
import { clearAddLocationState } from '../../Redux/Slicers/Location/AddLocationSlicer';
import MasterForm from './LocationForm';
import { createSearchParams, useNavigate, useParams } from 'react-router-dom';
import Master from '../Master/Masters';
import { encode } from '../../Utils/encodeDecode';
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined';
import { getOwner } from '../../Redux/Slicers/Owner/OwnerSlicer';
import { getOneLocation } from '../../Redux/Slicers/Location/GetOneLocationSlicer copy';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import { getMaster } from '../../Redux/Slicers/Master/MasterSlicer';
import { getDesignation } from '../../Redux/Slicers/Designation/DesignationSlicer';
import { getPricing } from '../../Redux/Slicers/Pricing/PricingSlicer';
import { getDayOfWeek } from '../../Redux/Slicers/DayOfWeek/DayOfWeekSlicer';
import { getSpecialDay } from '../../Redux/Slicers/SpecialDay/SpecialDaySlicer';
import { clearSpaceState } from '../../Redux/Slicers/Space/SpaceSlicer';
import { clearFixtureState } from '../../Redux/Slicers/Fixtures/FixtureSlicer';
import {
  AttachMoney,
  CurrencyExchangeOutlined,
  CurrencyPound,
} from '@mui/icons-material';
import { getAds } from '../../Redux/Slicers/Location/GetAdsSlicer';
const Location: FunctionComponent<MastersProps> = () => {
  const dispatch = useAppDispatch();
  const { data } = useAppSelector((state) => state?.Location);
  const [open, setOpen] = useState<boolean>(false);
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [deleteableName, setDeleteableName] = useState<string>('');
  const [deleteableId, setDeleteableId] = useState<number>(0);
  const [formik, setFormik] = useState<FormikProps<ILocationList>>();
  const { data: updateLocation, updateableDate } = useAppSelector(
    (state) => state?.UpdateLocation
  );
  const { data: addLocation } = useAppSelector((state) => state?.AddLocation);
  const { data: deleteLocationData } = useAppSelector(
    (state) => state.DeleteLocation
  );
  const nav = useNavigate();
  const screenSize = true;
  const isUpdateable =
    updateableDate && Object.keys(updateableDate).length !== 0;
  const column: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "number",
      maxWidth: 60,
    },
    {
      field: "first_name",
      renderHeader: () => <b>Owner Name</b>,
      flex: 1,
      type: "string",
      maxWidth: 120,
    },
    {
      field: "location_name",
      renderHeader: () => <b>Location Name</b>,
      flex: 1,
      type: "string",
      // maxWidth: 250,
    },

    // {
    //   field: "membership_price",
    //   renderHeader: () => <b>Membership Price</b>,
    //   flex: 1,
    //   type: "string",
    //   // maxWidth: 250,
    // },
    {
      field: "minimum_billing_time_unit",
      renderHeader: () => <b>Minimum Billing Time</b>,
      align: "center",
      headerAlign: "center",

      flex: 1,
      type: "string",
      // maxWidth: 250,
    },
    {
      field: "grace_time",
      renderHeader: () => <b>Grace Time</b>,
      align: "center",
      headerAlign: "center",

      flex: 1,
      type: "string",
      // maxWidth: 250,
    },
    {
      field: "location_address",
      renderHeader: () => <b>Address</b>,
      flex: 1,
      type: "string",
    },
    {
      field: "location_landmark",
      renderHeader: () => <b>Landmark</b>,
      flex: 1,
      type: "string",
      // maxWidth: 190,

      // valueGetter: (params: GridValueGetterParams<ILocationList>) =>
      //   params.row.role?.role_name,
    },
    {
      field: "location_lat",
      renderHeader: () => <b>Latitude</b>,
      flex: 1,
      type: "string",
      maxWidth: 140,

      // valueGetter: (params: GridValueGetterParams<ILocationList>) =>
      //   params.row.role?.role_name,
    },
    {
      field: "location_long",
      renderHeader: () => <b>Longitude</b>,
      flex: 1,
      type: "string",
      maxWidth: 140,

      // valueGetter: (params: GridValueGetterParams<ILocationList>) =>
      //   params.row.role?.role_name,
    },
    // {
    //   field: 'phone',
    //   renderHeader: () => <b>Contact Number</b>,
    //   flex: 1,
    //   type: 'string',
    //   maxWidth: 190,

    //   // valueGetter: (params: GridValueGetterParams<ILocationList>) =>
    //   //   params.row.role?.role_name,
    // },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "boolean",
      maxWidth: 70,

      renderCell: (params) => (
        <div>{params.value ? "Active" : "In-active"}</div>
      ),
      cellClassName: (params) => (params.value ? "active" : "inactive"),
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      maxWidth: 310,
      getActions: (params: GridRowParams<any>) => [
        <GridActionsCellItem
          key="View"
          label="View"
          icon={<View className="action_icons" />}
          onClick={() => {
            nav({
              pathname: `views/${params.row.id}`,
            });
            dispatch(getOneLocation(params.row.id));
          }}
        />,

        <GridActionsCellItem
          key="Edit"
          label="Edit"
          icon={<Edit className="action_icons" />}
          onClick={() => {
            dispatch(LocationsUpdateableData(params.row));
            setOpen(true);
          }}
        />,
        <GridActionsCellItem
          key="Delete"
          label="Delete"
          icon={<Delete className="action_icons" />}
          onClick={() => {
            setDeleteOpen(true);
            setDeleteableName(params.row.name ?? "");
            setDeleteableId(params.row.id!);
          }}
        />,
        <GridActionsCellItem
          key="User"
          label="User"
          title="Pricing"
          icon={<AttachMoney className="action_icon" />}
          onClick={() => {
            nav({
              pathname: `pricings/${params.row.id}`,
            });
            dispatch(getPricing(params.row.id));
            dispatch(getDayOfWeek(params.row.id));
            dispatch(getSpecialDay(params.row.id));
          }}
        />,
        <GridActionsCellItem
          key="User"
          label="User"
          title="Slot"
          icon={<ElectricCarIcon className="action_icon" />}
          onClick={() => {
            localStorage.setItem("fixture", "");
            localStorage.setItem("space", "");
            dispatch(clearSpaceState());
            dispatch(clearFixtureState());

            nav({
              pathname: `slot/${params.row.id}`,
            });
          }}
        />,
        <GridActionsCellItem
          key="User"
          label="User"
          title="AD'S"
          icon={
            <img
              src={ads}
              className="action_icon"
            />
          }
          onClick={() => {
            dispatch(getOneLocation(params.row.id));

            nav({
              pathname: `locAds/${params.row.id}`,
            });
          }}
        />,
        // <GridActionsCellItem
        //   key="adsHistory"
        //   label="Ads History"
        //   title="Ads History"
        //   icon={<AdsClickOutlinedIcon className="action_icons" />}
        //   onClick={() => {
        //     nav({
        //       pathname: `locAdsHistory/${params.row.id}`,
        //     });
        //     dispatch(getAds(params.row.id));
        //   }}
        // />,
        <GridActionsCellItem
          key="User"
          label="User"
          title="Designation"
          icon={<SupervisedUserCircleIcon className="action_icon" />}
          onClick={() => {
            dispatch(getMaster(null));

            nav({
              pathname: `designations/${params.row.id}`,
            });
          }}
        />,
        <GridActionsCellItem
          key="User"
          label="User"
          title="SpaceTypes"
          icon={<NoCrashIcon className="action_icon" />}
          onClick={() => {
            dispatch(getDesignation(params.row.id));
            nav({
              pathname: `SpaceTypes/${params.row.id}`,
            });
          }}
        />,
      ],

      cellClassName: "action_cell",
    },
  ];

  useEffect(() => {
    dispatch(getOwner());
    dispatch(getLocation());
  }, [updateLocation, addLocation, deleteLocationData]);

  useEffect(() => {
    return () => {
      dispatch(clearAddLocationState());
      dispatch(clearUpdateLocationState());
      dispatch(clearDeleteLocation());
    };
  }, []);
  const handleDialogClose = () => {
    setOpen(false);
    dispatch(clearUpdateLocationState());
  };

  const handleAddNewClick = () => {
    dispatch(clearUpdateLocationState());
    setOpen(true);
  };

  const data1 = data?.response?.data;

  const masterData = Array.isArray(data1)
    ? data1.map((master: any, index) => ({
        ...master,
        id: master._id,
        index: index + 1,
        first_name: master?.owner_id?.first_name,
      }))
    : [];

  const masterForm = (data: FormikProps<ILocationList>) => {
    setFormik(data);
  };

  return (
    <>
      <Table
        rows={masterData ?? []}
        columns={column}>
        <CustomToolbar>
          <h6>Location</h6>
          <TableSearch />
          <ButtonField
            className="add_button"
            onClick={handleAddNewClick}>
            <SvgIcon
              component={Add}
              inheritViewBox
            />
            Add New
          </ButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={open}
        dialogClassName="vehicle_dialog"
        dialogTitleClassName="master_dialog_title"
        // maxWidth={false}
        // fullScreen={screenSize}
        Dialog_Title={
          <>
            {isUpdateable ? 'Edit' : 'Add New Location'}
            <IconButtonField onClick={handleDialogClose}>
              <SvgIcon
                component={Cancel}
                inheritViewBox
              />
            </IconButtonField>
          </>
        }
        Dialog_Content={<MasterForm masterForm={masterForm} />}
        dialogActionClassName="master_dialog_action"
        Dialog_Actions={
          <>
            <ButtonField
              className="cancel_button"
              onClick={handleDialogClose}>
              Cancel
            </ButtonField>
            <ButtonField
              className="add_button"
              onClick={() => formik?.handleSubmit()}>
              {isUpdateable ? 'Update' : 'Save'}
            </ButtonField>
          </>
        }
      />

      <ResponseDialog
        response={addLocation}
        parentDialog={setOpen}
      />
      <ResponseDialog
        response={updateLocation}
        parentDialog={setOpen}
      />

      <DeleteDialog
        deleteableName={deleteableName}
        open={deleteOpen}
        setOpen={setDeleteOpen}
        deleteFunction={() => dispatch(deleteLocation(deleteableId))}
        response={deleteLocationData}
      />
    </>
  );
};

export default Location;
